<div class="user-select">
  <div class="user-content" v-if="!$slots.default" :class="{'is-error':isError,'disabled':disabled}">
    <div class="user-list"  @click="showModal">
      <span v-if="!tempUsers.length&&!tempRoles.length&&!tempProjectRoles.length" >请选择</span>
      <template v-else>
        <a-tag
          :disabled="disabled"
          v-for="role2 in tempProjectRoles"
          :key="role2.id"
          :closable="!disabled"
          color="blue"
          @close.prevent="deleteSelectedProjectRole(role2.id)"
        >
        <ant-icon type="TeamOutlined"></ant-icon>
        <span v-if="role2.valName.length<10">
          {{ role2.valName }}
        </span>
          <a-tooltip v-else :title="role2.valName" class="append-to-body" >
            {{role2.valName.slice(0,9)+'...'}}
          </a-tooltip>
        </a-tag>
        <a-tag
          :disabled="disabled"
          v-for="role in tempRoles"
          :key="role.id"
          :closable="!disabled"
          color="blue"
          @close.prevent="deleteSelectedRole(role.id)"
        >
        <ant-icon type="DeploymentUnitOutlined"></ant-icon>
        <span v-if="role.name.length<10">
          {{ role.name }}
        </span>
          <a-tooltip v-else :title="role.name" class="append-to-body" >
            {{role.name.slice(0,9)+'...'}}
          </a-tooltip>
        </a-tag>
        <a-tag
        :disabled="disabled"
        v-for="user in tempUsers"
        :key="user.id"
        :closable="!disabled"
        color="blue"
        @close.prevent="deleteSelectedUser(user.id)"
      >
      <ant-icon type="UserOutlined"></ant-icon>
      <span v-if="user.name.length<10">
        {{ user.name }}
      </span>
        <a-tooltip v-else :title="user.name" class="append-to-body" >
          {{user.name.slice(0,9)+'...'}}
        </a-tooltip>
      </a-tag>
      </template>
    </div>
    <div
      class="add-icon"
      v-if="tempUsers.length < maxCount"
      type="link"
      @click="showModal"
    >
      <img src="../../assets/images/icon_add.png" />
    </div>
  </div>

  <span v-if="$slots.default" @click="showModal">
    <slot></slot>
  </span>
  <a-modal
    v-model:visible="visible"
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    class="user-select-modal user-mod"
    width="820px"
    @cancel="cancelFn"
    @ok="ok"
  >
    <template #title>
      <span>{{title}}</span>
      <small v-if="maxCount && maxCount !== Infinity">本次操作最多可选 {{ maxCount }} 个员工</small>
      <small v-if="maxRoleCount && maxRoleCount !== Infinity">本次操作最多可选 {{ maxRoleCount }} 个角色</small>
    </template>
    <div class="user-select-modal__bd">
      <div class="user-select__left">
        <a-tabs v-model:activeKey="activeKey" >
          <a-tab-pane key="1" tab="项目角色" forceRender>
            <table-wrapper
            ref="tableRef2"
            :dataSource="projectRoles"
            @onSelectionChange="onSelectionChange2"
            :tableHeight="400"
            :columns="columns2"
          >
          </table-wrapper>
          </a-tab-pane>
          <a-tab-pane key="2" tab="组织角色" forceRender>
            <table-wrapper
          ref="tableRef"
          :dataSource="rolesData"
          @onSelectionChange="onSelectionChange"
          :tableHeight="400"
          :loading="loading"
          :columns="columns"
        >
        </table-wrapper>
          </a-tab-pane>
          <a-tab-pane key="3" tab="员工" forceRender>
            <div class="user-select__left__hd">
              <user-search-select
                v-model:value="userSearchId"
                class="w100"
                placeholder="输入员工姓名关键字"
                :activated-status="activatedStatus"
                :on-job="onJob"
                :status="status"
                :userState = "userStatus"
                @select="onUserSearchSelect"
              ></user-search-select>
            </div>
            <div class="user-select__left__bd">
              <vxe-table
              v-if="visible"
              :show-header="false"
              border="none"
              height="350"
              ref="xTree"
              :row-config="{keyField: 'id'}"
              :column-config="{resizable: true}"
              :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasEmployee', loadMethod: loadDepartment}"
              :data="treeData">
              <vxe-column field="name" title="公司员工" width="260" :tree-node="true">
                <template #default="{ row }">
                  <span :class="row.isLeaf&&!row.isDepartment?'is-leaf':''" @click="clickRow(row)">
                    <!-- <template v-if="row.children && row.children.length>0 && row.hasChildren">
                      <i class="tree-node-icon fa" :class="$refs.xTree.isTreeExpandByRow(row) ? 'fa-folder-open-o' : 'fa-folder-o'"></i>
                    </template> -->
                    <template v-if="row.isLeaf">
                      <user-outlined  v-if="!row.isDepartment"/>
                      <fork-outlined v-else/>
                    </template>
                    <template v-else>
                      <fork-outlined />
                    </template>
                    <span style="margin-left:6px;">{{ row.name }}</span>
                  </span>
                </template>
              </vxe-column>
            </vxe-table>
            </div>
          </a-tab-pane>
        </a-tabs>
       
      </div>
      <div class="user-select__right">
        <div class="user-select__right__hd">
          <span class="text-grey">已选择的成员 （ {{ tempUsers.length }} 个）</span>
          <span class="text-grey">已选择的角色 （ {{ tempProjectRoles.length +tempRoles.length }} 个）</span>
        </div>
        <div class="user-select__right__bd">
         
          <div v-for="item3 in tempProjectRoles" :key="item3.id" class="selected-user">
            <div class="selected-user__icon">
              <ant-icon type="TeamOutlined"></ant-icon>
            </div>
            <span>{{ item3.valName }}</span>
            <div class="selected-user__delete" @click="deleteTempProjectRole(item3.id)">
              <ant-icon type="CloseCircleOutlined"></ant-icon>
            </div>
          </div>
          <div v-for="item2 in tempRoles" :key="item2.id" class="selected-user">
            <div class="selected-user__icon">
              <ant-icon type="DeploymentUnitOutlined"></ant-icon>
              <!-- <deployment-unit-outlined /> -->
            </div>
            <span>{{ item2.name }}</span>
            <div class="selected-user__delete" @click="deleteTempRole(item2.id)">
              <ant-icon type="CloseCircleOutlined"></ant-icon>
            </div>
          </div>
          <div v-for="item in tempUsers" :key="item.id" class="selected-user">
            <div class="selected-user__icon">
              <ant-icon type="UserOutlined"></ant-icon>
            </div>
            <span>{{ item.name }}</span>
            <div class="selected-user__delete" @click="deleteTempUser(item.id)">
              <ant-icon type="CloseCircleOutlined"></ant-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</div>
